module.exports = __webpack_public_path__ + "static/media/eveready.68d2d9f5.svg";